<div>
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <div class="card">
        <form [formGroup]="expenseTransactionForm" (ngSubmit)="onSubmit()">
            <div class="row">
                <div class="col col-6">
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="basicInput">Proje Seçin</label>
                            <ng-select [items]="projects" bindValue="id" bindLabel="name"
                                formControlName="project"></ng-select>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="basicInput">Masraf Seçin</label>
                            <ng-select [items]="expenses" bindLabel="name" bindValue="id" groupBy="mainExpenseName"
                                formControlName="expense">
                                <ng-template ng-optgroup-tmp let-item="item">
                                    {{ item.mainExpenseName || 'Unnamed group' }}
                                </ng-template>
                            </ng-select>
                            <div *ngIf="expenseTransactionForm.get('expense')?.invalid && expenseTransactionForm.get('expense')?.touched"
                                class="text-danger">
                                Masraf seçimi zorunludur.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="basicInput">İşlem Tarih</label>
                            <ng2-flatpickr [setDate]="date" [config]="basicDateOptions"
                                formControlName="transactionDate"></ng2-flatpickr>
                            <div *ngIf="expenseTransactionForm.get('transactionDate')?.invalid && expenseTransactionForm.get('transactionDate')?.touched"
                                class="text-danger">
                                İşlem tarihi zorunludur.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="basicInput">Belge No</label>
                            <input type="text" class="form-control" formControlName="documentNo"
                                placeholder="Belge Numarası Giriniz." maxlength="16" />
                        </div>
                    </div>
                </div>
                <div class="col col-6">
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="basicInput">Tutar(KDV Dahil)</label>
                            <input type="number" class="form-control" formControlName="totalAmount"
                                placeholder="Tutar Giriniz.." />
                            <div *ngIf="expenseTransactionForm.get('totalAmount')?.invalid && expenseTransactionForm.get('totalAmount')?.touched"
                                class="text-danger">
                                Tutar zorunludur.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1" *ngIf="priceChanged">
                        <div class="form-group">
                            <label for="basicInput">Hesap Seçin</label>
                            <ng-select bindValue="id" bindLabel="name" formControlName="vaultId">
                                <ng-option *ngFor="let vault of vaults" [value]="vault.id">{{vault.title}} ({{vault.typeName}}) {{vault.totalPrice}}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="basicInput">KDV Oranı Seç</label>
                            <ng-select [items]="taxes" bindValue="id" bindLabel="taxRate"
                                formControlName="taxRate"></ng-select>

                            <div *ngIf="expenseTransactionForm.get('taxRate')?.invalid && expenseTransactionForm.get('taxRate')?.touched"
                                class="text-danger">
                                Kdv seçmek zorunludur.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <div class="form-group">
                            <label for="basicInput">Açıklama</label>
                            <fieldset class="form-group">
                                <textarea class="form-control" formControlName="description" rows="4"
                                    placeholder="Açıklama giriniz.."></textarea>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
            <button type="submit" class="btn btn-primary ml-1 mb-1" [disabled]="expenseTransactionForm.invalid">Masraf
                Güncelle</button>
        </form>
    </div>
</div>